/* ==========================================================================
   Cart drawer — comportamento
   1. Upsell "Adicionar" dentro do drawer: POST /cart/add.js pedindo as seções
      do drawer de volta e entregando pro <cart-drawer>.renderContents(), o
      mesmo caminho da vitrine (ahome-vitrine) e do quick-add do Shrine.
   2. Motion no padrão drsquatch.com: produto voa até o ícone girando 270deg,
      badge pulsa quando a contagem muda, ícone entra/sai girando.
   Tudo defensivo: sem seletor, sem efeito.
   ========================================================================== */
(function () {
  'use strict';

  var CART_ICON = '#cart-icon-bubble';
  var BADGE = '.cart-count-bubble';
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function icon() {
    return document.querySelector(CART_ICON);
  }

  function rootUrl() {
    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
    } catch (e) {}
    return '/';
  }

  /* ---- 1. upsell add-to-cart ---- */

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;
    var btn = event.target.closest('[data-sqc-add]');
    if (!btn) return;
    event.preventDefault();
    if (btn.classList.contains('is-loading')) return;

    var variantId = Number(btn.getAttribute('data-sqc-add'));
    if (!variantId) return;

    var drawer = document.querySelector('cart-drawer');
    var card = btn.closest('[data-sqc-upsell]');
    var img = card ? card.querySelector('img') : null;
    var label = btn.querySelector('.sqc__btn-label');
    var original = label ? label.textContent : '';

    btn.classList.add('is-loading');
    if (label) label.textContent = '...';
    flyToCart(img);

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else {
          window.location.href = rootUrl() + 'cart';
        }
      })
      .catch(function () {
        window.location.href = rootUrl() + 'cart';
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        if (label) label.textContent = original;
      });
  });

  /* ---- 2. motion ---- */

  function flyToCart(sourceImg) {
    if (reduceMotion || !sourceImg) return;
    var target = icon();
    if (!target) return;
    var from = sourceImg.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) return;

    var flyer = document.createElement('img');
    flyer.src = sourceImg.currentSrc || sourceImg.src;
    flyer.className = 'sq-flyer';
    flyer.style.top = from.top + 'px';
    flyer.style.left = from.left + 'px';
    flyer.style.width = from.width + 'px';
    flyer.style.height = from.height + 'px';
    document.body.appendChild(flyer);
    void flyer.offsetWidth;
    flyer.style.top = to.top + to.height / 2 - 12 + 'px';
    flyer.style.left = to.left + to.width / 2 - 12 + 'px';
    flyer.style.width = '24px';
    flyer.style.height = '24px';
    flyer.style.opacity = '0.2';
    flyer.style.rotate = '0deg';
    window.setTimeout(function () {
      if (flyer.parentNode) flyer.parentNode.removeChild(flyer);
      pulseIcon();
    }, 360);
  }

  function pulseIcon() {
    var target = icon();
    if (!target || reduceMotion) return;
    target.classList.remove('sq-cart-badge-pulse');
    void target.offsetWidth;
    target.classList.add('sq-cart-badge-pulse');
    window.setTimeout(function () {
      target.classList.remove('sq-cart-badge-pulse');
    }, 320);
  }

  function watchBadge() {
    var host = icon();
    if (!host || !window.MutationObserver) return;
    var last = (host.querySelector(BADGE) || {}).textContent || '';
    new MutationObserver(function () {
      var now = (host.querySelector(BADGE) || {}).textContent || '';
      if (now !== last) {
        last = now;
        pulseIcon();
      }
    }).observe(host, { childList: true, subtree: true, characterData: true });
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver || reduceMotion) return;
    var wasActive = drawer.classList.contains('active');
    new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive === wasActive) return;
      wasActive = isActive;
      var target = icon();
      if (!target) return;
      target.classList.remove('sq-cart-icon-in', 'sq-cart-icon-out');
      void target.offsetWidth;
      target.classList.add(isActive ? 'sq-cart-icon-in' : 'sq-cart-icon-out');
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---- 3. carrossel de upsell: arrastar com o mouse (touch/trackpad ja rolam nativo) ---- */

  function enableDrag(track) {
    if (!track || track.__sqDrag) return;
    track.__sqDrag = true;
    var down = false, moved = false, startX = 0, startLeft = 0;
    var swallow = null;
    function unswallow() {
      if (!swallow) return;
      track.removeEventListener('click', swallow, true);
      swallow = null;
    }
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      unswallow();
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      // is-dragging (pointer-events:none nos filhos) so' entra depois que o
      // mouse andou de verdade: se entrar aqui, o mousedown ja cai no trilho e o
      // click do botao "Adicionar" nasce com target errado e morre.
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4 && !moved) {
        moved = true;
        track.classList.add('is-dragging');
      }
      if (moved) track.scrollLeft = startLeft - dx;
    });
    function up() {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      if (moved) {
        // engole so' o click que fecha ESTE arrasto; se ele nao vier (soltou
        // fora), o engolidor some sozinho e nao come o proximo clique.
        swallow = function (ev) {
          ev.stopPropagation(); ev.preventDefault();
          unswallow();
        };
        track.addEventListener('click', swallow, true);
        window.setTimeout(unswallow, 300);
        window.setTimeout(function () { moved = false; }, 0);
      }
    }
    track.addEventListener('pointerup', up);
    track.addEventListener('pointerleave', up);
    track.addEventListener('pointercancel', up);
  }

  function watchCarousel() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var apply = function () {
      drawer.querySelectorAll('.sq-carousel').forEach(enableDrag);
    };
    apply();
    if (window.MutationObserver) {
      new MutationObserver(apply).observe(drawer, { childList: true, subtree: true });
    }
  }

  /* ---- 4. popup de cupom (promo-popup do Shrine): clicar fora fecha ----
     O overlay tem a classe promp-popup__close-btn mas o JS do tema só fecha
     pelo X e pelo "Perder desconto". Enquanto aberto, o overlay cobre a
     página inteira (z-index 1090) e engole todo clique — inclusive no
     "Adicionar" da vitrine. Aqui, clique no overlay = clique no X. */

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.classList || !t.classList.contains('popup-overlay')) return;
    if (!t.classList.contains('popup-overlay--active')) return;
    var host = t.closest('promo-popup') || document;
    var close = host.querySelector('.popup-modal--active .popup-modal__close') ||
      host.querySelector('.popup-modal__close');
    if (close) close.click();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var close = document.querySelector('promo-popup .popup-modal--active .popup-modal__close');
    if (close) close.click();
  });

  function init() {
    watchBadge();
    watchDrawer();
    watchCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
